import { Injectable, inject } from '@angular/core';

import type { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { IntegrationsApiService } from '@core/integrations-http-legacy';

import type { RemoteTemplate } from '../../../types';

@Injectable({ providedIn: 'root' })
export class RemoteTemplateHttpClient {
  private readonly httpApi = inject(IntegrationsApiService);

  public fetch(integrationKind: string): Observable<RemoteTemplate[]> {
    return this.httpApi
      .get(`field-mapping/i/${integrationKind}/remote-templates`)
      .pipe(map(({ templates }: { templates: RemoteTemplate[] }) => templates));
  }
}
